import {
  InvalidateQueryFilters,
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ARTICLE_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO, SimpleResponseDTO } from "interface";

type QueryOptionsWithoutMutationFn = Omit<
  UseMutationOptions<
    SimpleResponseDTO<number>,
    AxiosError<ErrorDTO>,
    number,
    unknown
  >,
  "mutationFn"
>;

export const useDeleteArticle = (options?: QueryOptionsWithoutMutationFn) => {
  const queryClient = useQueryClient();

  return useMutation<SimpleResponseDTO<number>, AxiosError<ErrorDTO>, number>({
    retry: 0,
    ...options,
    mutationFn: async (id: number) => {
      const result = await instance.delete<SimpleResponseDTO<number>>(
        `${ARTICLE_END_POINTS.delete}/${id}`
      );

      return result.data;
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries([
        ARTICLE_END_POINTS.list,
      ] as InvalidateQueryFilters);
      toast.success(`مقاله با موفقیت حذف گردید`);
    },
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data?.Message || "خطا در حذف مقاله"}`);
    },
  });
};
